import AppApi from "../apis/AppApi";
import AuthStore from "./AuthStore";
import CoachStore from "./CoachStore";
import WorkoutStore from "./WorkoutStore";
import WorkoutDetailStore from "./WorkoutDetailStore";
import ProfileStore from "./ProfileStore";
import SettingsStore from "./SettingsStore";
import MobileUserStore from "./MobileUserStore";
import CopyStore from "./CopyStore";
import SubscriptionPlanStore from "./SubscriptionPlanStore";

class Store {
  authStore = new AuthStore(this);
  coachStore = new CoachStore(this);
  workoutStore = new WorkoutStore(this);
  detailStore = new WorkoutDetailStore(this);
  profileStore = new ProfileStore(this);
  settingsStore = new SettingsStore(this);
  mobileUserStore = new MobileUserStore(this);
  copyStore = new CopyStore(this);
  subscriptionPlanStore = new SubscriptionPlanStore(this);
  api: AppApi | undefined;

  setApi(api: AppApi) {
    this.api = api;
  }
}

export default Store;
